import { render } from "./AccountWidget.vue?vue&type=template&id=131ed964&ts=true"
import script from "./AccountWidget.vue?vue&type=script&lang=ts"
export * from "./AccountWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__